var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { CSSTransition } from "react-transition-group";
import { cx } from "@emotion/css";
import { DEFAULT_ANIM_DURATION, DEFAULT_TRANSITION_CLASSNAMES, noop, TRANSITION_CLASSNAMES, } from "./const";
import styles from "./index.css";
export function LayerView(_a) {
    var active = _a.active, _b = _a.maskClosable, maskClosable = _b === void 0 ? true : _b, onClose = _a.onClose, renderContent = _a.renderContent, className = _a.className, maskClassName = _a.maskClassName, contentClassName = _a.contentClassName, _c = _a.disableTransition, disableTransition = _c === void 0 ? false : _c, _d = _a.transitionDuration, transitionDuration = _d === void 0 ? DEFAULT_ANIM_DURATION : _d, transitionClassNames = _a.transitionClassNames;
    var onMaskClick = function () {
        if (active && maskClosable)
            onClose === null || onClose === void 0 ? void 0 : onClose();
    };
    return (_jsx(CSSTransition, { appear: true, mountOnEnter: true, unmountOnExit: true, in: active, timeout: disableTransition ? 0 : transitionDuration, classNames: mergeClassNames(transitionClassNames || DEFAULT_TRANSITION_CLASSNAMES), children: _jsxs("div", { className: cx(styles.layer, !transitionClassNames
                ? styles.defaultTransition
                : undefined, className), children: [_jsx("div", { className: cx(styles.layerMask, maskClassName), onClick: onMaskClick }), _jsx("div", { className: cx(styles.layerContent, contentClassName), children: renderContent === null || renderContent === void 0 ? void 0 : renderContent({
                        onClose: onClose || noop,
                    }) })] }) }));
}
function mergeClassNames(classNames) {
    return Object.entries(TRANSITION_CLASSNAMES).reduce(function (prev, _a) {
        var _b = __read(_a, 2), key = _b[0], val = _b[1];
        prev[key] = val + (classNames[key] ? " ".concat(classNames[key]) : "");
        return prev;
    }, {});
}
